import { useLocalization } from 'model/localization.model';
import {h} from 'preact';
import { styled } from 'linaria/react';
import { Footer } from 'ui/footer';
import { Spinner } from 'ui/spinner';

export const PhotoLoading = () => {
	const t = useLocalization();

    return (
	    <Wrapper>
		    <Content>
			    <Spinner
				    fill={{
				    	primary: 'var(--primary-color)',
					    secondary: 'var(--secondary-color)'
				    }}
				    size={120}
			    />
			    <Text>{t('mobile.upload.hint')}</Text>
		    </Content>
		    <Footer/>
	    </Wrapper>
    )
};

const Text = styled('div')`
	margin: 48px 16px 0;
	font-style: normal;
	font-weight: normal;
	font-size: 16px;
	line-height: 24px;
	text-align: center;
	color: var(--text-primary);
`;
const Content = styled('div')`
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;
const Wrapper = styled('div')`
	display: flex;
	flex-direction: column;
	height: 100%;
`;
